/* Breakz — twinkle and occasional streaks on the background canvas.
 *
 * The dot grid is drawn in CSS and is always there. The canvas only adds
 * life to it, so with JS disabled or "reduce motion" on, the background
 * does not disappear, it simply stops twinkling. That is the separate
 * implementation for prefers-reduced-motion, not a slowed-down one.
 *
 * Markup and styles come from snippets/breakz-starfield.liquid. The
 * script finds every canvas on the page itself, so there is no need to
 * wire it into each section by hand.
 */
(function () {
  var CALM = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(canvas) {
    if (!canvas || !canvas.getContext || canvas.dataset.bxsfOn) return;
    // With "reduce motion" the canvas never starts at all.
    if (CALM.matches) return;
    canvas.dataset.bxsfOn = '1';

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var STEP = 26; // step matches the CSS dot grid
    var w = 0;
    var h = 0;
    var stars = [];
    var streak = null;
    var raf = 0;
    var next = 0;

    function build() {
      w = canvas.clientWidth;
      h = canvas.clientHeight;
      if (!w || !h) return;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      // Not the whole grid twinkles, only sparse nodes: if everything
      // blinks it is no longer a sky, it is fairy lights.
      stars = [];
      for (var y = STEP / 2; y < h; y += STEP) {
        for (var x = STEP / 2; x < w; x += STEP) {
          if (Math.random() < 0.055) {
            stars.push({
              x: x,
              y: y,
              p: Math.random() * 6.283,
              sp: 0.15 + Math.random() * 0.35, // period 8–20 s
              a: 0.16 + Math.random() * 0.3
            });
          }
        }
      }
    }

    var TAIL = 700; // tail length in milliseconds of travel

    function spawn(t) {
      // Once every 5–12 seconds. Rarer and nobody waits for it, more often
      // and the background turns into a screensaver.
      next = t + 5000 + Math.random() * 7000;
      var fromLeft = Math.random() < 0.5;
      streak = {
        x: fromLeft ? -180 : w + 180,
        y: h * (0.12 + Math.random() * 0.34),
        vx: (fromLeft ? 1 : -1) * (0.38 + Math.random() * 0.17),
        vy: 0.1 + Math.random() * 0.08,
        life: 0,
        span: 2600 + Math.random() * 1600
      };
    }

    function frame(t) {
      ctx.clearRect(0, 0, w, h);

      for (var i = 0; i < stars.length; i++) {
        var st = stars[i];
        var k = 0.5 + 0.5 * Math.sin(t * 0.001 * st.sp + st.p);
        ctx.globalAlpha = st.a * k;
        ctx.fillStyle = '#FCFCFC';
        ctx.fillRect(st.x, st.y, 1.4, 1.4);
      }

      if (!streak && t > next) spawn(t);
      if (streak) {
        streak.life += 16;
        var prog = streak.life / streak.span;
        if (prog >= 1) {
          streak = null;
        } else {
          var px = streak.x + streak.vx * streak.life;
          var py = streak.y + streak.vy * streak.life;
          var tx = px - streak.vx * TAIL;
          var ty = py - streak.vy * TAIL;
          // Fades in at the start and out at the end — no jerk on entry or exit.
          var fade = Math.sin(prog * Math.PI);

          var g = ctx.createLinearGradient(tx, ty, px, py);
          g.addColorStop(0, 'rgba(241,188,47,0)');
          g.addColorStop(0.7, 'rgba(241,188,47,' + (0.34 * fade).toFixed(3) + ')');
          g.addColorStop(1, 'rgba(255,248,133,' + (0.78 * fade).toFixed(3) + ')');

          ctx.globalAlpha = 1;
          ctx.strokeStyle = g;
          ctx.lineWidth = 1.7;
          ctx.lineCap = 'round';
          ctx.beginPath();
          ctx.moveTo(tx, ty);
          ctx.lineTo(px, py);
          ctx.stroke();

          // The head is brighter than the tail — otherwise the line reads as
          // a scratch rather than a flying object.
          ctx.fillStyle = 'rgba(255,248,133,' + (0.85 * fade).toFixed(3) + ')';
          ctx.beginPath();
          ctx.arc(px, py, 1.6, 0, 6.283);
          ctx.fill();
        }
      }

      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(frame);
    }

    function start() {
      if (!raf) raf = requestAnimationFrame(frame);
    }
    function stop() {
      if (raf) {
        cancelAnimationFrame(raf);
        raf = 0;
      }
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    var tm = 0;
    window.addEventListener('resize', function () {
      clearTimeout(tm);
      tm = setTimeout(build, 200);
    });

    build();
    next = performance.now() + 2200;
    start();
  }

  function boot() {
    document.querySelectorAll('canvas.bxsf-stars').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
